import React, { useEffect, useState } from 'react';
import { Grid, TextField, Button, Paper, Collapse } from '@material-ui/core'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { useDispatch, useSelector } from "react-redux";
import { SelectWithLabel } from "../../../../utils/selectWithLabel";
import { textPax, resetTextResults } from "../../../../store/dcs"
import { Send } from '@material-ui/icons';
import { TextTemplates } from './TextTemplates';
import { formatPax, formatRecipients, getRecipients } from './util';
import SendingText from "./SendingText";
import _ from 'lodash';

const TextPaxModal = (props) => {
  const modalClasses = props.modalClasses
  const dispatch = useDispatch()
  const [message, setMessage] = useState('')
  const [recipients, setRecipients] = useState(['ALL'])
  const [accordion, setAccordion] = useState(false)
  const textResults = useSelector(state => state.entities.dcs.textResults)
  const paxArr = formatPax(props.paxInfo)
  let recipientChoices = formatRecipients(paxArr)

  useEffect(() => {
    dispatch(resetTextResults())
  }, []);

  const handleRecipients = (newRecipient) => {
    // NOTE // if the new recipients array includes ALL and the old one doesn't, change recipients to just ALL
    if (newRecipient.includes('ALL') && !recipients.includes('ALL')) {
      setRecipients(['ALL'])
    }
    // NOTE // if the new recipients array has multiple recipients and the old array has ALL, remove ALL
    else if(newRecipient.length > 1 && recipients.includes('ALL')) {
      let recipientsCopy = _.cloneDeep(recipients)
      recipientsCopy.splice(recipientsCopy.indexOf('ALL'), 1)
      recipientsCopy = recipientsCopy.concat(newRecipient.splice(recipientsCopy.indexOf('ALL'), 1))
      setRecipients(recipientsCopy)
    }
    else {
      setRecipients(newRecipient)
    }
  }

  const handleSend = () => {
    let passengers = []
    if (recipients.includes('ALL')) {
      passengers = paxArr.filter(pax => pax.phone || pax.phoneNumber)
    }
    else {
      passengers = getRecipients(paxArr, recipients)
    }

    if (passengers.length && message) {
      dispatch(textPax(message, passengers))
    }
  }

  return (
    <Grid container justify="center" alignContent="center" style={{marginTop: '10%'}}>
      { Array.isArray(textResults) && textResults.length === 0 ?
        <Paper className={modalClasses.paper}>
          <Grid container item xs={12} justify="center" style={{fontSize: '60px', width: '100%', height: '20%', borderBottom: '2px solid rgba(201, 195, 195, 1)', backgroundColor: 'rgb(63, 81, 181, 1)'}}>
            <h5 style={{margin: '0px', paddingTop: '12px'}}>Text Pax</h5>
          </Grid>
          <Grid container item xs={12} style={{paddingTop: '5px', paddingBottom: '5px', borderBottom: '2px solid rgba(201, 195, 195, 1)'}}>
            <Grid container item xs={12} justify="center">
              <SelectWithLabel defaultVal={recipients} handleChange={(e) => {handleRecipients(e.target.value)}} inputLabel={'Recipients'} items={recipientChoices} multiple customStyle={{width: '65%'}} />
            </Grid>
            <Grid container justifyContent="center" item xs={12}>
              <Grid container justifyContent="center" alignContent="center" item xs={12} style={{height: '48px'}}>
                <Button variant="contained" size="small" color="primary" onClick={() => setAccordion(!accordion)}>
                  {accordion ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />} Templates
                </Button>
              </Grid>
              <Collapse in={accordion} timeout="auto" unmountOnExit>
                  <TextTemplates setMsg={setMessage} setAccordion={setAccordion} />
              </Collapse>
            </Grid>
          </Grid>
          <Grid container item xs={12} style={{paddingTop: '3em', paddingLeft: '5em', paddingRight: '5em', height: '60%' }}>
            <TextField
              id="filled-multiline-static"
              label="Message"
              multiline
              rows={10}
              value={message}
              onChange={(e) => {setMessage(e.target.value)}}
              variant="filled"
              style={{width: '100%', height: 'inherit'}}
            />
          </Grid>
          <Grid container style={{marginBottom: '5%', marginTop: '5%'}}>
            <Grid style={{textAlign: 'center'}} item lg={7} xs={12}>
              <p style={{color: 'red', fontSize: 'large', marginTop: '5px'}}>
                {!paxArr || !recipients.length || !message.length ? 'You need recipients and a message to send' : ''}
              </p>
            </Grid>
            <Grid item xs={3} lg={1}></Grid>
            <Grid item xs={3} lg={1} style={{marginRight: '5%'}}>
              { paxArr && recipients && message.length ? <Button onClick={() => {handleSend()}} variant="contained" color="primary" endIcon={<Send />}>Send</Button> : <Button variant="contained" disabled color="primary" endIcon={<Send />}>Send</Button> }
            </Grid>
            <Grid item xs={3} lg={1}>
              <Button variant="contained" onClick={() => {props.closeModal(false)}} style={{backgroundColor: '#eb494e'}}>Close</Button>
            </Grid>
          </Grid>
        </Paper> :
        <SendingText modalClasses={modalClasses} closeModal={props.closeModal} textResults={textResults} />
      }
    </Grid>
  )
}

export default TextPaxModal